<template>
  <div>
    <!-- ==================== HERO SECTION ==================== -->
    <!-- Desktop Hero Carousel -->
    <div class="hidden sm:block">
      <carousel
        :perPage="1"
        :paginationPosition="'bottom-overlay'"
        :navigationEnabled="true"
        navigationNextLabel="<i class='fa fa-arrow-right'></i>"
        navigationPrevLabel="<i class='fa fa-arrow-left'></i>"
      >
        <slide v-for="(i, index) in 3" :key="'slide-' + index">
          <div class="oneSlide">
            <img :src="`/Images/${i}.jpg`" alt="The Company" />
          </div>
        </slide>
      </carousel>
    </div>

    <!-- Mobile Hero Carousel -->
    <div class="block sm:hidden">
      <carousel
        :perPage="1"
        :paginationPosition="'bottom-overlay'"
        :navigationEnabled="true"
        navigationNextLabel="<i class='fa fa-arrow-right'></i>"
        navigationPrevLabel="<i class='fa fa-arrow-left'></i>"
      >
        <slide v-for="(i, index) in 3" :key="'m-slide-' + index">
          <div class="oneSlide">
            <img :src="`/Images/mobile/${i}.jpg`" alt="The Company" />
          </div>
        </slide>
      </carousel>
    </div>

    <!-- ==================== ABOUT SECTION ==================== -->
    <div id="About" class="About">
      <div class="wrapper shadow-lg rounded-md my-5">
        <div class="mt-5">
          <h2 class="text-2xl font-bold mb-6 text-center md:text-start">
            {{ $t("Section.AboutTitle") }}
          </h2>

          <div class="md:flex gap-8 items-start">
            <!-- Text Side -->
            <div class="md:w-2/3">
              <div class="prose max-w-none leading-relaxed" style="direction: rtl; text-align: right">
                <p>
                  ئاگۆرا دەنگ بریتیە لە پلاتفۆرمێکی دیجیتاڵی پەرتوکی دەنگیی
                  کوردی. پلاتفۆرمەکە بە هەرسێ جۆری وێبسایت و ئەپلیکەیشنی
                  ئەندرۆید و ئەپلیکەیشنی ئەپڵ بەردەستە بۆ بەکارهێنان.
                </p>
                <br />
                <p>
                  ئەو بابەت و نووسەرو خوێنەرانەی پلاتفۆرمی ئاگۆرا دەنگ پێک
                  دەهێنن بەردەوام لە زیادبووندایەو هەروەها بەکارهێنەرانی
                  پلاتفۆرمەکەش بە هەمان شێوە.
                </p>
                <br />
                <p>
                  پلاتفۆرمی ئاگۆرا دەنگ یەکێکە لە بەرهەمەکانی کۆمپانیای
                  <a href="https://www.agoravision.site" style="color: #3e9f9d">ئاگۆرا ڤیژن</a>
                  بۆ پەخش و بڵاوکردنەوەی دیجیتاڵی، سنوردار.
                </p>
                <br />
                <p>
                  بۆ تاقی کردنەوەی ئاگۆرا دەنگ و گوێگرتن لە نمونەی خۆڕایی سەرجەم
                  بابەتەکان، تکایە لەم بازاڕانەی خوارەوە ئەپڵیکەیشنەکە دابەزێنە.
                </p>

                <!-- App Download Buttons -->
                <div class="flex flex-col sm:flex-row gap-6 my-12">
                  <a
                    href="https://play.google.com/store/apps/details?id=site.agoravision.agoradeng&hl=en"
                    target="_blank"
                    class="group flex justify-center items-center gap-4 bg-black hover:bg-gray-900 text-white px-8 py-4 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-xl min-w-[260px]"
                  >
                    دابەزاندن لە ڕێگەی گوگڵ پلەی ستۆر
                    <img
                      src="https://cdn-icons-png.flaticon.com/256/300/300218.png"
                      alt="Get it on Google Play"
                      class="h-10 w-auto"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/iq/app/agora-deng-%D8%A6%D8%A7%DA%AF%DB%86%D8%B1%D8%A7-%D8%AF%DB%95%D9%86%DA%AF/id1622027385"
                    target="_blank"
                    class="group flex justify-center items-center gap-4 bg-black hover:bg-gray-900 text-white px-8 py-4 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-xl min-w-[260px]"
                  >
                    دابەزاندن لە ڕێگەی ئەپڵ ئەپ ستۆر
                    <img
                      src="https://developer.apple.com/assets/elements/icons/app-store-connect/app-store-connect-128x128_2x.png"
                      alt="Download on the App Store"
                      class="h-10 w-auto"
                    />
                  </a>
                </div>
              </div>
            </div>

            <!-- Image Side -->
            <div class="md:w-1/3 mt-8 md:mt-0 flex justify-center md:justify-start">
              <img
                src="/Images/co_app.png"
                alt="Agora Deng App"
                class="rounded-lg max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== FEATURED SECTION (REBUILT) ==================== -->
    <div id="Featured" class="Featured py-12 bg-white">
      <div class="max-w-7xl mx-auto px-4">

        <!-- Books Section -->
        <div class="mb-16">
          <div class="text-right mb-8">
            <h2 class="text-3xl font-bold text-teal-600 mb-2">هەڵبژاردەیەک لە بابەتەکانی ئاگۆرا دەنگ</h2>
            
          </div>

          <!-- Custom Books Slider -->
          <div class="custom-slider-container">
            <!-- Navigation Buttons -->
            <button 
              @click="scrollBooks('prev')" 
              class="slider-nav slider-nav--prev"
              :class="{ 'slider-nav--disabled': booksAtStart }"
            >
              <i class="fa fa-chevron-right"></i>
            </button>
            
            <button 
              @click="scrollBooks('next')" 
              class="slider-nav slider-nav--next"
              :class="{ 'slider-nav--disabled': booksAtEnd }"
            >
              <i class="fa fa-chevron-left"></i>
            </button>

            <!-- Scrollable Track -->
            <div 
              ref="booksTrack" 
              class="slider-track"
              @scroll="updateBooksScrollState"
            >
              <div 
                v-for="(book, index) in books" 
                :key="'book-' + index"
                class="slider-item slider-item--book"
              >
                <div class="book-card">
                  <div class="book-card__image">
                    <img :src="book.image" :alt="book.title" />
                  </div>
                  <p class="book-card__title">{{ book.title }}</p>
                </div>
              </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-pagination">
              <span 
                v-for="(dot, index) in booksDots" 
                :key="'book-dot-' + index"
                class="slider-dot"
                :class="{ 'slider-dot--active': index === booksActiveDot }"
                @click="scrollBooksTo(index)"
              ></span>
            </div>
          </div>
        </div>

        <!-- Authors Section -->
        <div>
          <div class="text-right mb-8">
            <h2 class="text-3xl font-bold text-teal-600 mb-2">هەڵبژاردەیەک لە نووسەرەکانی ئاگۆرا دەنگ</h2>
            
          </div>

          <!-- Custom Authors Slider -->
          <div class="custom-slider-container">
            <!-- Navigation Buttons -->
            <button 
              @click="scrollAuthors('prev')" 
              class="slider-nav slider-nav--prev"
              :class="{ 'slider-nav--disabled': authorsAtStart }"
            >
              <i class="fa fa-chevron-right"></i>
            </button>
            
            <button 
              @click="scrollAuthors('next')" 
              class="slider-nav slider-nav--next"
              :class="{ 'slider-nav--disabled': authorsAtEnd }"
            >
              <i class="fa fa-chevron-left"></i>
            </button>

            <!-- Scrollable Track -->
            <div 
              ref="authorsTrack" 
              class="slider-track"
              @scroll="updateAuthorsScrollState"
            >
              <div 
                v-for="(author, index) in authors" 
                :key="'author-' + index"
                class="slider-item slider-item--author"
              >
                <div class="author-card">
                  <div class="author-card__image">
                    <img :src="author.image" :alt="author.name" />
                  </div>
                  <p class="author-card__name">{{ author.name }}</p>
                </div>
              </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-pagination">
              <span 
                v-for="(dot, index) in authorsDots" 
                :key="'author-dot-' + index"
                class="slider-dot"
                :class="{ 'slider-dot--active': index === authorsActiveDot }"
                @click="scrollAuthorsTo(index)"
              ></span>
            </div>
          </div>
        </div>
        <router-link to="/more" class="bg-agora text-white font-medium px-10 py-3.5 rounded-xl transition-all text-lg shadow-lg hover:shadow-xl" style="    margin: 35px auto; display: block; text-align: center; width: 160px;">
          زیاتر ببینە
        </router-link>
      </div>
    </div>

    <!-- ==================== SAMPLES SECTION (REBUILT) ==================== -->
    <div id="Samples" class="Samples py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4">

        <!-- Header -->
        <div class="text-right mb-10">
          <h2 class="text-3xl font-bold text-teal-600 mb-2">نموونەی دەنگی هەندێک لە بابەتەکان</h2>
          <p class="text-gray-600 text-lg">گوێ لە نموونەی دەنگی بابەتەکان بگرە</p>
        </div>

        <!-- Custom Videos Slider -->
        <div class="custom-slider-container custom-slider-container--videos">
          <!-- Navigation Buttons -->
          <button 
            @click="scrollVideos('prev')" 
            class="slider-nav slider-nav--prev"
            :class="{ 'slider-nav--disabled': videosAtStart }"
          >
            <i class="fa fa-chevron-right text-xl"></i>
          </button>
          
          <button 
            @click="scrollVideos('next')" 
            class="slider-nav slider-nav--next"
            :class="{ 'slider-nav--disabled': videosAtEnd }"
          >
            <i class="fa fa-chevron-left text-xl"></i>
          </button>

          <!-- Scrollable Track -->
          <div 
            ref="videosTrack" 
            class="slider-track"
            @scroll="updateVideosScrollState"
          >
            <div 
              v-for="(video, index) in videos" 
              :key="'video-' + index"
              class="slider-item slider-item--video"
            >
              <div class="video-card" @click="playVideo(video.url)">
                <!-- Thumbnail -->
                <div class="video-card__thumbnail">
                  <img :src="video.thumbnail" :alt="video.title" />
                  
                  <!-- Play Button Overlay -->
                  <div class="video-card__overlay">
                    <div class="video-card__play-btn">
                      <i class="fa fa-play"></i>
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination Dots -->
          <div class="slider-pagination">
            <span 
              v-for="(dot, index) in videosDots" 
              :key="'video-dot-' + index"
              class="slider-dot"
              :class="{ 'slider-dot--active': index === videosActiveDot }"
              @click="scrollVideosTo(index)"
            ></span>
          </div>
        </div>

        <!-- Bottom CTA Button -->
        <div class="flex justify-center mt-12">
          <a
            href="https://www.youtube.com/@agoravisioncom"
            target="_blank"
            class="bg-agora text-white font-medium px-10 py-3.5 rounded-xl transition-all text-lg shadow-lg hover:shadow-xl"
          >
            بۆ گوێگرتن لە نموونەی زیاتر کلیک لێرە بکە
          </a>
        </div>

      </div>
    </div>

    <!-- ==================== FAQ SECTION ==================== -->
    <div id="FAQ" class="FAQ py-16 bg-white">
      <div class="wrapper max-w-5xl mx-auto px-4">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-teal-600 mb-2">پرسیارە باوەکان</h2>
          <p class="text-gray-600 text-lg">ئەو پرسیارانەی زۆرترین جار لێمان دەکرێن</p>
        </div>

        <div class="max-w-3xl mx-auto space-y-4">
          <!-- FAQ 1 -->
          <div class="bg-gray-50 rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <button
              @click="toggleFAQ(1)"
              class="w-full px-6 py-5 flex items-center justify-between text-right focus:outline-none hover:bg-gray-100 transition-colors"
            >
              <span class="text-lg font-medium text-gray-800">
                ١ - ئەپڵیکەیشنی ئاگۆرا دەنگ چییە؟
              </span>
              <span
                class="text-2xl text-teal-600 transition-transform duration-300"
                :class="{ 'rotate-45': openFAQ === 1 }"
              >
                +
              </span>
            </button>
            <div
              v-show="openFAQ === 1"
              class="px-6 pb-6 text-gray-700 leading-relaxed border-t border-gray-200"
            >
              <p class="pt-4">
                ئاگۆرا دەنگ بریتیە لە یەکەمین ئەپڵیکەیشنی کتێبی دەنگیی کوردی، کە
                بە هەرسێ جۆری وێبسایت و ئەپلیکەیشنی ئەندرۆید و ئەپلیکەیشنی ئای
                ئۆ ئێس بەردەستە بۆ بەکارهێنان.
              </p>
            </div>
          </div>

          <!-- FAQ 2 -->
          <div class="bg-gray-50 rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <button
              @click="toggleFAQ(2)"
              class="w-full px-6 py-5 flex items-center justify-between text-right focus:outline-none hover:bg-gray-100 transition-colors"
            >
              <span class="text-lg font-medium text-gray-800">
                ٢ - پەیوەندی نێوان ئاگۆرا دەنگ و کۆمپانیای ئاگۆرا ڤیژن چییە؟
              </span>
              <span
                class="text-2xl text-teal-600 transition-transform duration-300"
                :class="{ 'rotate-45': openFAQ === 2 }"
              >
                +
              </span>
            </button>
            <div
              v-show="openFAQ === 2"
              class="px-6 pb-6 text-gray-700 leading-relaxed border-t border-gray-200"
            >
              <p class="pt-4">
                کۆمپانیای ئاگۆرا ڤیژن ئەو قەوارە یاساییەیە کە خاوەندارێتی و
                بەڕێوەبەرێتی ئەپڵیکەیشنی ئاگۆرا دەنگ دەکات.
                <a
                  href="https://www.agoravision.site/"
                  target="_blank"
                  class="text-teal-600 hover:underline"
                >
                  زانیاری زیاتر
                </a>
              </p>
            </div>
          </div>

          <!-- FAQ 3 -->
          <div class="bg-gray-50 rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <button
              @click="toggleFAQ(3)"
              class="w-full px-6 py-5 flex items-center justify-between text-right focus:outline-none hover:bg-gray-100 transition-colors"
            >
              <span class="text-lg font-medium text-gray-800">
                ٣ - ئەپڵیکەیشنی ئاگۆرا دەنگ بە چی زاراوەیەک بەردەستە؟
              </span>
              <span
                class="text-2xl text-teal-600 transition-transform duration-300"
                :class="{ 'rotate-45': openFAQ === 3 }"
              >
                +
              </span>
            </button>
            <div
              v-show="openFAQ === 3"
              class="px-6 pb-6 text-gray-700 leading-relaxed border-t border-gray-200"
            >
              <p class="pt-4">
                لە ئێستادا ئاگۆرا دەنگ تەنها بە زاراوەی سۆرانی (کوردی ناوەڕاست)
                بەردەستە بەڵام لە کارکردنداین بۆ زیادکردنی بەرهەم و روکاری
                ئەپلیکەیشنەکە بە زاراوەکانی تریش لە داهاتوویەکی نزیکدا.
              </p>
            </div>
          </div>
        </div>

        <!-- Link to Full FAQ -->
        <div class="text-center my-16">
          <p class="text-gray-600 mb-4">هێشتا پرسیارت هەیە؟</p>
          <router-link
            to="/faq"
            class="bg-agora inline-flex items-center gap-3 text-white font-medium text-xl px-12 py-5 rounded-3xl transition-all duration-300 shadow-lg hover:shadow-2xl"
          >
            سەرجەم پرسیارە باوەکان ببینە
          </router-link>
        </div>
      </div>
    </div>

    <!-- ==================== CONTACT SECTION ==================== -->
    <div id="Contact" class="Contact">
      <div class="wrapper shadow-lg rounded-md my-5">
        <div>
          <form @submit.prevent="sendEmail" ref="form" id="contactForm">
            <h2 class="text-2xl font-bold mb-2">
              {{ $t("Section.ContactTitle") }}
            </h2>

            <div class="aboveForm">
              <p>
                {{ $t("ContactForm.Heading") }}
                <br /><br />
                <span>{{ $t("ContactForm.subheading") }}</span>
              </p>

              <div class="text-xs mt-4">
                <p class="font-bold" v-html="$t('ContactForm.working')"></p>
                <br />
                <h3 class="font-bold text-lg siteColor" v-html="$t('ContactForm.Iraq.name')"></h3>
                <br />
                <span class="text-sm" v-html="$t('ContactForm.Iraq.address')"></span>
                <br />
                <span class="text-sm font-bold">
                  <a href="tel:009647702000545">{{ $t("ContactForm.PhoneOne") }}</a>
                  |
                  <a href="tel:009647502000545">{{ $t("ContactForm.PhoneTwo") }}</a>
                </span>
                <br /><br />
                <h3 class="font-bold text-lg siteColor" v-html="$t('ContactForm.Canada.name')"></h3>
                <br />
                <span class="text-sm" v-html="$t('ContactForm.Canada.address')"></span>
                <br />
                <span class="text-sm font-bold">
                  <a href="tel:0017767781476">{{ $t("ContactForm.PhoneCanada") }}</a>
                </span>
              </div>

              <br />
              <p>{{ $t("ContactForm.Sub") }}</p>
            </div>

            <label for="user_name">{{ $t("ContactForm.Name") }}</label>
            <input
              required
              v-model="contact.name"
              type="text"
              name="user_name"
              class="block w-full h-8 rounded shadow-lg my-2 px-2 outline-none transition hover:shadow-md"
            />

            <label for="user_email">{{ $t("ContactForm.Email") }}</label>
            <input
              required
              v-model="contact.mail"
              type="email"
              name="user_email"
              class="block w-full h-8 rounded shadow-lg my-2 px-2 outline-none transition hover:shadow-md"
            />

            <label for="user_phone">{{ $t("ContactForm.Phone") }}</label>
            <input
              required
              v-model="contact.phone"
              type="tel"
              name="user_phone"
              class="block w-full h-8 rounded shadow-lg my-2 px-2 outline-none transition hover:shadow-md"
            />

            <label for="message" class="block">{{ $t("ContactForm.Message") }}</label>
            <textarea
              required
              v-model="contact.message"
              name="message"
              class="block w-full h-24 rounded shadow-lg my-2 px-2 outline-none transition hover:shadow-md"
            ></textarea>

            <button
              class="mt-3 block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition"
            >
              {{ $t("Send") }}
            </button>
          </form>
        </div>

        <div class="w-50">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.5323177804235!2d45.432587515609875!3d35.56525094393079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40002dc3c9af9dcb%3A0x1382709528a56a1e!2zQWdvcmEgVmlzaW9uINim2Kfar9uG2LHYpyDapNuM2pjZhg!5e0!3m2!1sen!2siq!4v1657790412965!5m2!1sen!2siq"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import emailjs from "@emailjs/browser";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  
  components: {
    Carousel,
    Slide,
  },

  computed: {
    ...mapGetters(["getCurrentLocale", "getCurrentDir", "getPosts", "Lang"]),

    // Books slider computed
    booksDots() {
      return Math.ceil(this.books.length / this.booksPerPage);
    },

    // Authors slider computed
    authorsDots() {
      return Math.ceil(this.authors.length / this.authorsPerPage);
    },

    // Videos slider computed
    videosDots() {
      return Math.ceil(this.videos.length / this.videosPerPage);
    },
  },

  data() {
    return {
      openFAQ: null,

      // Books slider state
      booksPerPage: 4,
      booksActiveDot: 0,
      booksAtStart: true,
      booksAtEnd: false,

      // Authors slider state
      authorsPerPage: 4,
      authorsActiveDot: 0,
      authorsAtStart: true,
      authorsAtEnd: false,

      // Videos slider state
      videosPerPage: 3,
      videosActiveDot: 0,
      videosAtStart: true,
      videosAtEnd: false,

      // Data
      videos: [
        {
          thumbnail: "/Images/samples/v1.jpg",
          title: "شەربەتی ترس",
          url: "https://www.youtube.com/shorts/1eI9r_mdYnk",
          duration: "12:45",
        },
        {
          thumbnail: "/Images/samples/v2.jpg",
          title: "لەو ڕۆژیلە وەفا نەمەن",
          url: "https://www.youtube.com/shorts/2aJZgegb6Uc",
          duration: "08:30",
        },
        {
          thumbnail: "/Images/samples/v3.jpg",
          title: "سێبه‌ری با",
          url: "https://www.youtube.com/shorts/QQKTmZALX6c",
          duration: "15:20",
        },
        {
          thumbnail: "/Images/samples/v4.jpg",
          title: "بیرۆکەکانی سەرکەوتن",
          url: "https://www.youtube.com/shorts/UqgwWbvQdSU",
          duration: "10:10",
        },
        {
          thumbnail: "/Images/samples/v5.jpg",
          title: "محەمەد عەلی کەلای",
          url: "https://www.youtube.com/shorts/rrFhPjpZ5So",
          duration: "22:05",
        },
        {
          thumbnail: "/Images/samples/v6.jpg",
          title: "پازدە ساڵ ژیان",
          url: "https://www.youtube.com/shorts/hVJK6B-3_9g",
          duration: "22:05",
        },
      ],

      books: [
        { image: "/Images/books/1.jpg", name: "پڕ بە پێست" },
        { image: "/Images/books/2.jpg", name: "سیزیف: ئەو کوڕەی کە دوو دڵی هەیە" },
        { image: "/Images/books/3.jpg", name: "ڕۆڵی ڕووداوەکانی شنگال لە پێشخستنی دۆزی کورد " },
        { image: "/Images/books/4.jpg", name: "پەنجەرەکانی ماڵێکی نا تەواو" },
        { image: "/Images/books/5.jpg", name: "شادمانییەکانی ژیانم" },
        { image: "/Images/books/6.jpg", name: "هونەری چیرۆک" },
        { image: "/Images/books/7.jpg", name: "پێنج کاتژمێر" },
        { image: "/Images/books/8.jpg", name: "پڕۆسەی پەروەردە لە سەردەمی جیهانگیری تەکنەلۆجیادا" },
        { image: "/Images/books/9.jpg", name: "بەرەو کەناری شپرزەیی" }
      ],

      authors: [
        { image: "/Images/authors/1.png", name: "نەرمین عوسمان" },
        { image: "/Images/authors/2.png", name: "پەیام ئبراهیم" },
        { image: "/Images/authors/3.png", name: "عەزیز پیری" },
        { image: "/Images/authors/4.png", name: "سامان خانەقینی" },
        { image: "/Images/authors/5.png", name: "ساماڵ مانیی" },
        { image: "/Images/authors/6.png", name: "سەعید ڤەرۆژ" },
        { image: "/Images/authors/7.png", name: "ئەندریا پێشڕەو" },
        { image: "/Images/authors/8.png", name: "جەلیل کاکەوەیس" },
        { image: "/Images/authors/9.png", name: "عومەر سەید" }
      ],

      contact: {
        name: null,
        mail: null,
        phone: null,
        message: null,
      },
    };
  },

  mounted() {
    this.updateResponsiveSettings();
    window.addEventListener("resize", this.updateResponsiveSettings);
    
    // Initial scroll state check
    this.$nextTick(() => {
      this.updateBooksScrollState();
      this.updateAuthorsScrollState();
      this.updateVideosScrollState();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateResponsiveSettings);
  },

  methods: {
    // Responsive settings
    updateResponsiveSettings() {
      const width = window.innerWidth;
      
      if (width < 640) {
        this.booksPerPage = 2;
        this.authorsPerPage = 2;
        this.videosPerPage = 1;
      } else if (width < 1024) {
        this.booksPerPage = 3;
        this.authorsPerPage = 3;
        this.videosPerPage = 2;
      } else if (width < 1280) {
        this.booksPerPage = 4;
        this.authorsPerPage = 4;
        this.videosPerPage = 3;
      } else {
        this.booksPerPage = 5;
        this.authorsPerPage = 5;
        this.videosPerPage = 4;
      }
    },

    // ===== BOOKS SLIDER METHODS =====
    scrollBooks(direction) {
      const track = this.$refs.booksTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollAmount = itemWidth * this.booksPerPage;

      if (direction === "next") {
        track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    },

    scrollBooksTo(index) {
      const track = this.$refs.booksTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollPosition = (this.booksDots - 1 - index) * itemWidth * this.booksPerPage;
      
      track.scrollTo({ left: scrollPosition, behavior: "smooth" });
    },

    updateBooksScrollState() {
      const track = this.$refs.booksTrack;
      if (!track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      this.booksAtEnd = currentScroll <= 10;
      this.booksAtStart = currentScroll >= maxScroll - 10;

      // Update active dot
      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollPerPage = itemWidth * this.booksPerPage;
      const invertedScroll = maxScroll - currentScroll;
      this.booksActiveDot = Math.round(invertedScroll / scrollPerPage);
    },

    // ===== AUTHORS SLIDER METHODS =====
    scrollAuthors(direction) {
      const track = this.$refs.authorsTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollAmount = itemWidth * this.authorsPerPage;

      if (direction === "next") {
        track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    },

    scrollAuthorsTo(index) {
      const track = this.$refs.authorsTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollPosition = (this.authorsDots - 1 - index) * itemWidth * this.authorsPerPage;
      
      track.scrollTo({ left: scrollPosition, behavior: "smooth" });
    },

    updateAuthorsScrollState() {
      const track = this.$refs.authorsTrack;
      if (!track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      this.authorsAtEnd = currentScroll <= 10;
      this.authorsAtStart = currentScroll >= maxScroll - 10;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 200;
      const scrollPerPage = itemWidth * this.authorsPerPage;
      const invertedScroll = maxScroll - currentScroll;
      this.authorsActiveDot = Math.round(invertedScroll / scrollPerPage);
    },

    // ===== VIDEOS SLIDER METHODS =====
    scrollVideos(direction) {
      const track = this.$refs.videosTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 280;
      const scrollAmount = itemWidth * this.videosPerPage;

      if (direction === "next") {
        track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    },

    scrollVideosTo(index) {
      const track = this.$refs.videosTrack;
      if (!track) return;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 280;
      const scrollPosition = (this.videosDots - 1 - index) * itemWidth * this.videosPerPage;
      
      track.scrollTo({ left: scrollPosition, behavior: "smooth" });
    },

    updateVideosScrollState() {
      const track = this.$refs.videosTrack;
      if (!track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      this.videosAtEnd = currentScroll <= 10;
      this.videosAtStart = currentScroll >= maxScroll - 10;

      const itemWidth = track.querySelector(".slider-item")?.offsetWidth || 280;
      const scrollPerPage = itemWidth * this.videosPerPage;
      const invertedScroll = maxScroll - currentScroll;
      this.videosActiveDot = Math.round(invertedScroll / scrollPerPage);
    },

    // ===== OTHER METHODS =====
    toggleFAQ(id) {
      this.openFAQ = this.openFAQ === id ? null : id;
    },

    playVideo(url) {
      window.open(url, "_blank");
    },
//Service ID service_it8ziaq
//Template ID template_fro9gmk
//user ID user_Mhdpo0N7SP8VnDjdVXPda
    sendEmail() {
      this.$loading(true);
      emailjs
        .sendForm(
         "service_it8ziaq",
          "template_fro9gmk",
          this.$refs.form,
          "user_Mhdpo0N7SP8VnDjdVXPda"
        )
        .then(
          (result) => {
            console.log(result);
            this.contact = {
              name: null,
              mail: null,
              phone: null,
              message: null,
            };
            this.$loading(false);
            this.$vToastify.success(
              this.getCurrentLocale == "ku"
                ? "ئیمەیڵ بە سەرکەوتوویی نێردرا."
                : "Email was sent successfully.",
              this.getCurrentLocale == "ku" ? "سەرکەوتن!" : "Success!"
            );
          },
          (error) => {
            console.log(error);
            this.$loading(false);
            this.$vToastify.error(
              this.getCurrentLocale == "ku"
                ? "تکایە پەیوەندی بکە بە سەرپەرشتیاری وێب سایتەوە."
                : "Please contact website administrator.",
              this.getCurrentLocale == "ku"
                ? "هەڵەیەک ڕوویدا."
                : "An error occurred."
            );
          }
        );
    },
  },
};
</script>

<style scoped>
/* ===== HERO CAROUSEL FIX ===== */
.VueCarousel {
  direction: ltr !important;
}

.VueCarousel-inner {
  direction: ltr !important;
}

.VueCarousel-slide {
  direction: rtl !important;
}

.oneSlide {
  width: 100%;
  overflow: hidden;
}

.oneSlide img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== CUSTOM SLIDER CONTAINER ===== */
.custom-slider-container {
  position: relative;
  padding: 0 50px;
}

@media (max-width: 640px) {
  .custom-slider-container {
    padding: 0 40px;
  }
}

/* ===== SLIDER TRACK ===== */
.slider-track {
  display: flex;
  flex-direction: row-reverse; /* RTL support */
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  padding: 10px 0;
}

.slider-track::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

/* ===== SLIDER ITEMS ===== */
.slider-item {
  flex-shrink: 0;
}

.slider-item--book {
  width: calc(20% - 13px); /* 5 items */
}

.slider-item--author {
  width: calc(20% - 13px); /* 5 items */
}

.slider-item--video {
  width: calc(25% - 12px); /* 4 items */
}

/* Responsive widths */
@media (max-width: 1280px) {
  .slider-item--book,
  .slider-item--author {
    width: calc(25% - 12px); /* 4 items */
  }
  .slider-item--video {
    width: calc(33.333% - 11px); /* 3 items */
  }
}

@media (max-width: 1024px) {
  .slider-item--book,
  .slider-item--author {
    width: calc(33.333% - 11px); /* 3 items */
  }
  .slider-item--video {
    width: calc(50% - 8px); /* 2 items */
  }
}

@media (max-width: 640px) {
  .slider-item--book,
  .slider-item--author {
    width: calc(50% - 8px); /* 2 items */
  }
  .slider-item--video {
    width: 100%; /* 1 item */
  }
}

/* ===== NAVIGATION BUTTONS ===== */
.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: white;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  color: #0d9488;
}

.slider-nav:hover {
  background: #0d9488;
  color: white;
  box-shadow: 0 6px 20px rgba(13, 148, 136, 0.3);
}

.slider-nav--prev {
  right: 0;
}

.slider-nav--next {
  left: 0;
}

.slider-nav--disabled {
  opacity: 0.3;
  pointer-events: none;
}

@media (max-width: 640px) {
  .slider-nav {
    width: 36px;
    height: 36px;
  }
}

/* ===== PAGINATION DOTS ===== */
.slider-pagination {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  direction: rtl;
}

.slider-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d1d5db;
  cursor: pointer;
  transition: all 0.3s ease;
}

.slider-dot:hover {
  background: #9ca3af;
}

.slider-dot--active {
  background: #0d9488;
  transform: scale(1.2);
}

/* ===== BOOK CARD ===== */
.book-card {
  text-align: center;
}

.book-card__image {
  aspect-ratio: 2 / 3;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.book-card__image:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transform: translateY(-4px);
}

.book-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.book-card__title {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ===== AUTHOR CARD ===== */
.author-card {
  text-align: center;
}

.author-card__image {
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: #f3f4f6;
  transition: all 0.3s ease;
}

.author-card__image:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transform: translateY(-4px);
}

.author-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.author-card__name {
  margin-top: 12px;
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
}

/* ===== VIDEO CARD ===== */
.video-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.video-card:hover {
  transform: translateY(-4px);
}

.video-card__thumbnail {
  position: relative;
  aspect-ratio: 2/3;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  background: #e5e7eb;
}

.video-card__thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  transition: background 0.3s ease;
}

.video-card:hover .video-card__overlay {
  background: rgba(0, 0, 0, 0.4);
}

.video-card__play-btn {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.video-card:hover .video-card__play-btn {
  transform: scale(1.1);
}

.video-card__play-btn i {
  color: #0d9488;
  font-size: 24px;
  margin-left: 4px;
}

.video-card__duration {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
}

.video-card__title {
  margin-top: 16px;
  text-align: right;
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3em;
}

/* ===== VIDEOS SECTION SPECIFIC ===== */
.custom-slider-container--videos {
  padding: 0 60px;
}

@media (max-width: 640px) {
  .custom-slider-container--videos {
    padding: 0 45px;
  }
}

/* ===== FAQ ANIMATION ===== */
.rotate-45 {
  transform: rotate(45deg);
}

/* ===== FADE ANIMATION ===== */
@keyframes fadeDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}
</style>